export const local= "http://localhost:5011/api"
export const prod = "https://plapi.addislearning.edu.et/api"